import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { BehaviorSubject, Observable, Subject, takeUntil } from 'rxjs';
import { LEPartnerService } from '../../../../services/lepartner.service';
import { AppConstants } from '../../../../shared/app.constants';
import { TableRowSelectEvent } from 'primeng/table';

@Component({
  selector: 'ness-lepartner-search-user-form',
  templateUrl: './lepartner-search-user-form.component.html',
  styles: ['.card-title > h3 { font-size: 1.1em !important; font-weight: 700; }',
  '.form-group .form-group { margin-bottom: 0; }']
})
export class LEPartnerSearchUserComponent implements OnInit, OnDestroy {
  @Input() agencyIdToSearch: string = null;
  @Output() onSelectedUser = new EventEmitter<ServerModels.ENESS_LEPartnerDTO>();

  searchResultTableCols = [
    { field: 'LastName', header: 'Last name' },
    { field: 'FirstName', header: 'First name' },
    { field: 'ENESS_XREF_LEPartnersPhoneNumbers', header: 'Primary Phone Number' },
    { field: 'ENESS_XREF_LEPartnersEmailAccounts', header: 'Email' }
  ];
  selectedPerson: ServerModels.ENESS_LEPartnerDTO;
  rows: number = AppConstants.defaultTableRows;
  findAPartnerForm: FormGroup = this._fb.group({
    SearchInput: ['', Validators.required]
  });

  private _findLEPartnerResults: ServerModels.ENESS_LEPartnerDTO[] = [];
  findLEPartnerResults: BehaviorSubject<ServerModels.ENESS_LEPartnerDTO[]> = new BehaviorSubject<ServerModels.ENESS_LEPartnerDTO[]>(this._findLEPartnerResults);
  findLEPartnerResults$: Observable<ServerModels.ENESS_LEPartnerDTO[]> = this.findLEPartnerResults.asObservable();

  private _destroyed$: Subject<void> = new Subject<void>();

  constructor(private _lEPartnerService: LEPartnerService,
    private _fb: FormBuilder,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.messageService.clear('findLEPartnerMsg');
  }

  ngOnDestroy() {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  onSearchPerson(): void {
    const searchTerm = this.findAPartnerForm.get('SearchInput').value;
    if (!searchTerm)
      return;

    this._lEPartnerService.findUserByNameAndAgency(this.agencyIdToSearch, searchTerm).pipe(takeUntil(this._destroyed$)).subscribe(
      (users: ServerModels.ENESS_LEPartnerDTO[]) => {
        this._findLEPartnerResults = users;
        this.findLEPartnerResults.next(this._findLEPartnerResults);
      },
      (err:any) => this.messageService.add({ key: 'findLEPartnerMsg', severity: 'error', summary: 'Error:', detail: err.error || err.error.ExceptionMessage || err.error.Message }),
      () => {
        this.findAPartnerForm.reset({
          SearchInput: ''
        })
      });
  }

  public onSelectPartner(event: TableRowSelectEvent): void {
    this.selectedPerson = event.data;
    this.onSelectedUser.emit(this.selectedPerson);
    this.clearAllFields();
  }

  private clearAllFields() {
    this.findAPartnerForm.reset({
      SearchInput: ''
    });
    this._findLEPartnerResults = [];
    this.findLEPartnerResults.next(this._findLEPartnerResults);
    this.selectedPerson = null;
  }
}
